// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.RequestRentAmountChangeWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RequestRentAmountChangeWebApiRequestDto, RequestRentAmountChangeWebApiResponseDto } from '../..';

export const RequestRentAmountChangeWebApiHandler_requestRentAmountChange_Path = '/api/web/v1/requestRentAmountChange';

/**
 * Request a rent amount change for a landlord property
 */
export const RequestRentAmountChangeWebApiHandler_requestRentAmountChange = (
  postData: RequestRentAmountChangeWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RequestRentAmountChangeWebApiRequestDto, RequestRentAmountChangeWebApiResponseDto>(
    {
      endpoint: RequestRentAmountChangeWebApiHandler_requestRentAmountChange_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
